import React from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useFeatures } from '../../hooks/Features/useFeatures'
import SubCategory from './SubCategory'

function EditSubCategory() {
  const params = useParams()

  const { getSubCategory, subCategory } = useFeatures()
  //console.log('SUBCATEGORY : ', subCategory)
  React.useEffect(() => {
    getSubCategory({ subcategoryId: params.subcategoryId })
  }, [params.subcategoryId])

  return <>{!subCategory ? <Loader /> : <SubCategory subcategory={subCategory} />}</>
}

export default EditSubCategory
